import React, { useState } from 'react';

import { CgCloseR } from 'react-icons/cg';
import "./OptionChip.scss";

const OptionChip = (props) => {


const onCloseClickAction = (e) => {
    e.preventDefault();
    props.onCloseClick(e, props.id);
}

    return (
        <div className="ochip-wrapper" name={props.id}>
        <span key={props.id}>{props.text}</span>
        <span onClick={onCloseClickAction}><CgCloseR size="1.1rem" /></span>
        </div>
    );
}

export default OptionChip